import './components/lazyload';
import ButtonUtils from './components/buttons';
import './components/insurers-carousel';
import './components/article-share';
import './components/topic-nav-dropdown';
import './components/topic-nav-toggle';
import './components/insurer-key-features';
import './components/csrf';
import './components/declaration-forms/index';

require('svg4everybody')();
require('./components/popups');
require('./components/glossary-term');
require('./components/nav-search');
require('./components/nav-toggle');
require('./components/nav-flyout');
require('./components/nav-sub-nav');
require('./components/trustpilot');
require('./components/accordion');
require('./components/masonry');
require('./components/insurer-summary');
require('./components/password-input');
require('./components/video');
require('./components/search');
require('./components/ctm-form');
require('./components/google-optimize');
require('./components/adobe-tracking');
require('./components/toggle');
require('./components/insurance-types');

$('.js-topic-nav').on('click', function () {
    $(this)
        .closest('.topic-nav')
        .toggleClass('topic-nav--open')
        .find('> ul')
        .slideToggle();
});

if ($('.js-hidden-btn').length) {
    new ButtonUtils($('.hero'));
}

$('.gtm-broker-login').on('submit', () => {
    window.dataLayer.push({
        event: 'brokerAccount',
        accountAction: 'Login',
    });
});
